import gql from 'graphql-tag'

export const GET_ALL_DIGIO_AUTO_DEBIT_SCHEDULE_REQUESTS = gql`
  query Query($where: WhereGetAutoScheduleRequest) {
    getDigioAutoScheduleRequestData(where: $where)
  }
`
